export type Theme = 'system-default' | 'force-light' | 'force-dark';
export const THEME_EVENT_NAME = 'kompendiumTheme';
